import * as React from 'react';
import SignatureCanvas from 'react-signature-canvas';

import { trimCanvas } from '@/ui-kit/signature/trimCanvas';

import './signature-drawer.css';

interface SignatureDrawerProps extends React.HTMLAttributes<HTMLDivElement> {
  onSignatureDrew: (signature: string) => void;
}

const SignatureDrawer = React.forwardRef<SignatureCanvas, SignatureDrawerProps>(
  ({ onSignatureDrew }, ref) => {
    const signatureCanvasRef = React.useRef<SignatureCanvas | null>(null);

    React.useImperativeHandle(
      ref,
      () => signatureCanvasRef.current as SignatureCanvas,
    );

    return (
      <div className="signature-drawer__container">
        <SignatureCanvas
          onEnd={() => {
            if (signatureCanvasRef.current) {
              // Trim whitespace so the signature renders larger in the PDF.
              const base =
                // react-signature-canvas provides this, but keep a safe fallback.
                typeof (signatureCanvasRef.current as any).getTrimmedCanvas ===
                'function'
                  ? (signatureCanvasRef.current as any).getTrimmedCanvas()
                  : signatureCanvasRef.current.getCanvas();

              const signature = trimCanvas(base, { paddingPx: 12 }).toDataURL(
                'image/png',
              );
              onSignatureDrew(signature);
            }
          }}
          ref={ref => {
            signatureCanvasRef.current = ref;
          }}
          canvasProps={{ className: 'signature-drawer__canvas' }}
        />
      </div>
    );
  },
);

export { SignatureDrawer };
